/* eslint-disable no-unused-vars */

import {
  Route,
  Routes as ReactRouterRoutes,
  Navigate,
} from 'react-router-dom';

import Layout from 'components/Layout';
import NoResultFound from 'components/NotFound';
import Applications from 'pages/Applications';
import Application from 'pages/Application';
import Executions from 'pages/Executions';
import Execution from 'pages/Execution';
import Flows from 'pages/Flows';
import Flow from 'pages/Flow';
import EditorRoutes from 'pages/Editor/routes';
import * as URLS from 'config/urls';

function Routes() {
  return (
    <ReactRouterRoutes>
      <Route
        path={URLS.EXECUTIONS}
        element={
          <Layout>
            <Executions />
          </Layout>
        }
      />

      <Route
        path={URLS.EXECUTION_PATTERN}
        element={
          <Layout>
            <Execution />
          </Layout>
        }
      />

      <Route
        path={`${URLS.FLOWS}/*`}
        element={
          <Layout>
            <Flows />
          </Layout>
        }
      />

      <Route
        path={`${URLS.APPS}/*`}
        element={
          <Layout>
            <Applications />
          </Layout>
        }
      />

      <Route
        path={`${URLS.APP_PATTERN}/*`}
        element={
          <Layout>
            <Application />
          </Layout>
        }
      />

      <Route path={`${URLS.EDITOR}/*`} element={<EditorRoutes />} />

      <Route
        path="/"
        element={
          <Navigate to={URLS.FLOWS} replace />
        }
      />

      <Route path="*" element={<NoResultFound />} />
    </ReactRouterRoutes>
  );
}

export default <Routes />;
